import React from 'react';
import { 	createValidationHelper, 
			validateRequired, 
			validateEmpty, 
			validateEmail,
			validateMax }
			from './lib/validation-helpers.js';
import InputControl from './input-control.js';
import SelectControl from './select-control.js';
import TextAreaControl from './textarea-control';
import 'airbnb-js-shims';
import moment from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DatePicker from './date-picker';
import getDateString, { getDateStdString, parseDateString } from "./lib/getDateString";
moment.extend(utc);

export default class HonorCardEmailForm extends React.Component {
	constructor(props) {
		super(props);

		this.MAX_MESSAGE_CHAR = 250;
		this.MAX_SIGNATURE_CHAR = 80;  
		
		const initialFormConfig = this.getInitialFormState();

		this.state = initialFormConfig;

		const validationConfig = {
			sender_name: {
				validators: [validateRequired],
			},
			sender_email: {
				validators: [validateRequired, validateEmail],
			},
			recipient_name: {
				validators: [validateRequired],
			},
			recipient_email: {
				validators: [validateRequired, validateEmail],
			},
			ehonor_card_subject: {
				validators: [validateRequired],
			},
			ehonor_card_message: {
				validators: [validateRequired, validateMax(this.MAX_MESSAGE_CHAR)],
			},
			ehonor_card_signature: {
				validators: [validateRequired, validateMax(this.MAX_SIGNATURE_CHAR)],
			},
		};

		this.formName = 'ehonorcardemail';
		// Register and Bind FormMethods from form wrapper
		this.bindLocalMethods = props.bindLocalMethods.bind(this);
		this.bindLocalMethods();

		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlePreview = this.handlePreview.bind(this);
		
		this.validationHelper = createValidationHelper(validationConfig);
	}

	componentDidMount() {
	}

	showSuccessState(fieldState) {
		return fieldState.isValid;
	}
	
	showErrorState(fieldState) {
		return !fieldState.isValid && fieldState.secondInteraction;
	}

	handleDateChange(value) {
		this.setState((prevState) => {
			prevState.dateInput = value;
			return prevState;
		});
	}

	handlePreview(e) {
		const fieldData = this.state.fields; 
		this.props.handlePreview(fieldData);
	}

	handleSubmit(e) {
		const data = {
			'sender_name': this.state.fields.sender_name.value,
			'sender_email': this.state.fields.sender_email.value,
			'recipient_name': this.state.fields.recipient_name.value,
			'recipient_email': this.state.fields.recipient_email.value,
			'ehonor_card_subject': this.state.fields.ehonor_card_subject.value,
			'ehonor_card_message': this.state.fields.ehonor_card_message.value,
			'ehonor_card_signature': this.state.fields.ehonor_card_signature.value,
			'ehonor_card_send_date': new Date(getDateStdString(parseDateString(this.state.dateInput))).toISOString(),
			'selected_product_id': this.props.product.valueKey
		};

		jQuery.ajax({
			url: window.wvus_ehonor_card_ajax_vars.wvus_ehonor_card_ajax_url,
			type: 'post',
			data: {
				action: 'wvus_ehonor_card_email_send',
				security: window.wvus_ehonor_card_ajax_vars.wvus_ehonor_card_ajax_nonce,				
				'wvus_ehonor_card_email_form_data': data,
			},
			success: function(data){
				const sentMessage = <div className="alert alert-success" role="alert">
				<i className="fa fa-check-circle" aria-hidden="true"></i> Thank you for sending a card to { this.state.fields.recipient_name.value }.</div>;

				this.eHonorCardSendSuccess();
				this.setState((prevState) => {
					prevState = this.getInitialFormState();
					return prevState;
				});
				this.props.resetFormAfterSend(sentMessage);
			}.bind(this),
			error: function(errorThrown) {
				this.setState((prevState) => {
					prevState.formError = true;
					return prevState;
				});
				this.eHonorCardSendFailure();
			}.bind(this)
		});

		this.props.scrollToTop();
	}

	getInitialFormState() {

		const initialState = {
			fields: {
				sender_name: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',
				},
				sender_email: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',					
				},
				recipient_name: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',
				},
				recipient_email: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',				
				},
				ehonor_card_subject: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',	
				},
				ehonor_card_message: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',		
				},
				ehonor_card_signature: {
					value: '',
					secondInteraction: false,
					isValid: false,
					errorMessage: '',		
				},
			},
			// dateInput: moment().utc(),
			dateInput: getDateString(new Date()),
			formValid: false,
			formSent: false,
			formError: false,
		};

		return initialState;
	}

	getMessageCharacterCount(maxCount, count) {
		return maxCount - count;
	}

	eHonorCardSendSuccess() {
	}

	eHonorCardSendFailure() {
	}

	render() {
		const maximumDate = moment().add(60, 'day');

		const messageCharacterCount = this.getMessageCharacterCount(this.MAX_MESSAGE_CHAR, this.state.fields.ehonor_card_message.value.length);

		const signatureCharacterCount = this.getMessageCharacterCount(this.MAX_SIGNATURE_CHAR, this.state.fields.ehonor_card_signature.value.length);

		const errorMessage = this.state.formError ? <div className="alert alert-danger" role="alert">
		<i className="fa fa-times-circle" aria-hidden="true"></i> An unexpected error has occurred, please try again.</div> : '';

		return (
			<div className="ehonor-card-email-form" data-ehonor-card-email-form>
				<div className="ehonor-card-fields">
					
					  { errorMessage }

					  <InputControl
						fieldName="sender_name"
						fieldClasses="sender_name"
						fieldTitle="Sender Name"
						fieldState={this.state.fields.sender_name} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="text" 
						fieldPlaceholder="Name"
						showUISuccess={this.showUISuccess(this.state.fields.sender_name)}
						showUIError={this.showUIError(this.state.fields.sender_name)}
						>
					</InputControl>
					<InputControl
						fieldName="sender_email"
						fieldClasses="sender_email"
						fieldTitle="Sender Email"
						fieldState={this.state.fields.sender_email} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="email" 
						fieldPlaceholder="name@example.com"
						showUISuccess={this.showUISuccess(this.state.fields.sender_email)}
						showUIError={this.showUIError(this.state.fields.sender_email)}
						>
					</InputControl>
					<InputControl
						fieldName="recipient_name"
						fieldClasses="recipient_name"
						fieldTitle="Recipient Name"
						fieldState={this.state.fields.recipient_name} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="text" 
						fieldPlaceholder="Name"
						showUISuccess={this.showUISuccess(this.state.fields.recipient_name)}
						showUIError={this.showUIError(this.state.fields.recipient_name)}
						>
					</InputControl>
					<InputControl
						fieldName="recipient_email"
						fieldClasses="recipient_email"
						fieldTitle="Recipient Email"
						fieldState={this.state.fields.recipient_email} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="email" 
						fieldPlaceholder="name@example.com"
						showUISuccess={this.showUISuccess(this.state.fields.recipient_email)}
						showUIError={this.showUIError(this.state.fields.recipient_email)}
						>
					</InputControl>
					<InputControl
						fieldName="ehonor_card_subject"
						fieldClasses="ehonor_card_subject"
						fieldTitle="Subject"
						fieldState={this.state.fields.ehonor_card_subject} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="text" 
						fieldPlaceholder="Subject: A gift has been sent in your honor"
						showUISuccess={this.showUISuccess(this.state.fields.ehonor_card_subject)}
						showUIError={this.showUIError(this.state.fields.ehonor_card_subject)}
						>
					</InputControl>
					<TextAreaControl 
						fieldName="ehonor_card_message"
						fieldClasses="ehonor_card_message"
						fieldTitle="Message"												
						fieldState={this.state.fields.ehonor_card_message} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldRows={6}
						fieldPlaceholder="Enter message to recipient here (max 250 characters)."
						showUISuccess={this.showUISuccess(this.state.fields.ehonor_card_message)}
						showUIError={this.showUIError(this.state.fields.ehonor_card_message)}
						characterCount={messageCharacterCount}
						>
					</TextAreaControl>
					<InputControl
						fieldName="ehonor_card_signature"
						fieldClasses="ehonor_card_signature"
						fieldTitle="Signature"
						fieldState={this.state.fields.ehonor_card_signature} 
						handleBlur={this.handleBlur} 
						handleValueChange={this.handleValueChange} 
						fieldType="text" 
						fieldPlaceholder="Signature (max 80 characters)"
						showUISuccess={this.showUISuccess(this.state.fields.ehonor_card_signature)}
						showUIError={this.showUIError(this.state.fields.ehonor_card_signature)}
						characterCount={signatureCharacterCount}
						>
					</InputControl>

					<div className="ehonor-card-send-date form-group">
            			<label htmlFor="ehonor-card-send-date">Select send date</label>
						<div className="form-control-wrapper">
							<DatePicker 
								date={this.state.dateInput}
								onDateChange={this.handleDateChange}
								focused={this.state.focused}
								numberOfMonths={2}
								hideKeyboardShortcutsPanel={true}
								isDayBlocked={(day) => day.isAfter(maximumDate)}
								onFocusChange={({ focused }) => this.setState({ focused })}
							/>
						</div>
					</div>

				</div>
				<button 
					type="button" 
					className="btn btn-large btn-secondary preview-btn"
					disabled={!this.state.formValid}
					onClick={this.handlePreview}
					data-continue-from-ehonor-card-email>
					Preview eCard
				</button>
				<button 
					type="button" 
					className="btn btn-large btn-primary send-btn"
					disabled={!this.state.formValid}
					onClick={this.handleSubmit}
					data-continue-from-ehonor-card-email>
					Send
				</button>
			</div>
		);
	}


}